// @flow
export type PurchaseInnerTrackingState = '0' | '1p' | '2p' | '3p' | '4p' | '5p';
export type SaleInnerTrackingState = '1s' | '2s' | '3s' | '4s' | '5s';

export type PurchaseInnerThreeState = '0' | '1p' | '2p' | '3p';
export type SaleInnerThreeState = '0' | '1s' | '2s' | '3s';

export type StateConvertResponse = {
  innerState: PurchaseInnerTrackingState | SaleInnerTrackingState;
  labelIntl?: string;
  labelIntlShort?: string;
  labelIntlLong?: string;
  hasExtra?: boolean;
};

// const purchaseInnerTrackingStates: PurchaseInnerTrackingState[] = ['1p', '2p', '3p', '4p', '5p'];
const purchaseInnerTrackingStates: PurchaseInnerTrackingState[] = ['1p', '3p', '4p', '5p'];
const saleInnerTrackingState: SaleInnerTrackingState[] = ['1s', '2s', '3s', '4s', '5s'];
/*

___ 0 ___
CREATED
CREATED_FOR_COURIER
AVAILABLE
AVAILABLE_FOR_COURIER

BUYER_CANCELED
QEMPO_CANCELED
TRAVELER_CANCELED
RETURNED
QEMPO_CANCELED_FOR_FRAUD

ABANDONED
EXPIRED

___ 1 ___
RESERVED
IN_COURIER_FLOW

___ 2 ___
PURCHASED

___ 2 ___
RECEIVED

___ 3 ___
ARRIVED
IN_QEMPO

___ 4 ___
IN_QEMPO_CONFIRMED
SHIPPING
DELIVERED

___ 5 ___
DELIVERY_CONFIRMED

 */

const saleConverter = (state: string): StateConvertResponse => {
  switch (state) {
    case 'BUYER_CANCELED':
    case 'QEMPO_CANCELED':
    case 'TRAVELER_CANCELED':
    case 'RETURNED':
    case 'QEMPO_CANCELED_FOR_FRAUD':
      return {
        innerState: '0',
        labelIntl: 'order.sale.canceled.title',
        labelIntlShort: 'order.sale.canceled.title.short',
        hasExtra: false,
      };
    case 'RESERVED':
      return {
        innerState: '1s',
        labelIntl: 'order.sale.reserved.title',
        labelIntlShort: 'order.sale.reserved.title.short',
        hasExtra: false,
      };
    case 'PURCHASED':
      return {
        innerState: '2s',
        labelIntl: 'order.sale.purchased.title',
        labelIntlShort: 'order.sale.purchased.title.short',
        hasExtra: false,
      };
    case 'RECEIVED':
      return {
        innerState: '3s',
        labelIntl: 'order.sale.received.title',
        labelIntlShort: 'order.sale.received.title.short',
        hasExtra: false,
      };
    case 'ARRIVED':
      return {
        innerState: '4s',
        labelIntl: 'order.sale.deliver.title',
        labelIntlShort: 'order.sale.deliver.title.short',
        hasExtra: false,
      };
    case 'SHIPPING':
    case 'IN_QEMPO':
    case 'IN_QEMPO_CONFIRMED':
    case 'DELIVERED':
    case 'DELIVERY_CONFIRMED':
      return {
        innerState: '5s',
        labelIntl: 'order.sale.completed.title',
        labelIntlShort: 'order.sale.completed.title.short',
        hasExtra: false,
      };
    case 'ABANDONED':
    case 'EXPIRED':
    default:
      return {
        innerState: '0',
        labelIntl: 'order.sale.abandoned.title',
        labelIntlShort: 'order.sale.abandoned.title.short',
        hasExtra: false,
      };
  }
};

const purchaseConverter = (state: string): StateConvertResponse => {
  switch (state) {
    case 'CREATED':
    case 'CREATED_FOR_COURIER':
      return {
        innerState: '0',
        labelIntl: 'order.purchase.unconfirmedPayment.title',
        labelIntlShort: 'order.purchase.unconfirmedPayment.title.short',
        hasExtra: false,
      };
    case 'AVAILABLE':
    case 'RESERVED':
      return {
        innerState: '0',
        labelIntl: 'order.purchase.lookingForTravelers.title',
        labelIntlShort: 'order.purchase.lookingForTravelers.title.short',
        hasExtra: false,
      };
    case 'BUYER_CANCELED':
    case 'QEMPO_CANCELED':
    case 'TRAVELER_CANCELED':
    case 'RETURNED':
    case 'QEMPO_CANCELED_FOR_FRAUD':
      return {
        innerState: '0',
        labelIntl: 'order.purchase.buyer.canceled.title',
        labelIntlShort: 'order.purchase.buyer.canceled.title',
        hasExtra: false,
      };
    case 'AVAILABLE_FOR_COURIER':
      return {
        innerState: '1p',
        labelIntl: 'order.purchase.registerPurchase.title',
        labelIntlShort: 'order.purchase.registerPurchase.title.short',
        labelIntlLong: 'order.purchase.registerPurchase.title.long',
        hasExtra: false,
      };
    case 'IN_COURIER_FLOW':
      return {
        innerState: '1p',
        labelIntl: 'order.purchase.courierFlow.title',
        labelIntlShort: 'order.purchase.courierFlow.title.short',
        labelIntlLong: 'order.purchase.courierFlow.title.long',
        hasExtra: false,
      };
    case 'PURCHASED':
      return {
        innerState: '1p',
        labelIntl: 'order.purchase.purchased.title',
        labelIntlShort: 'order.purchase.purchased.title.short',
        labelIntlLong: 'order.purchase.purchased.title.long',
        hasExtra: false,
      };
    case 'RECEIVED':
      return {
        /*innerState: '2p',
        labelIntl: 'order.purchase.received.title',
        labelIntlShort: 'order.purchase.received.title.short',
        labelIntlLong: 'order.purchase.received.title.long',
        hasExtra: false,*/
        innerState: '1p',
        labelIntl: 'order.purchase.purchased.title',
        labelIntlShort: 'order.purchase.purchased.title.short',
        labelIntlLong: 'order.purchase.purchased.title.long',
        hasExtra: false,
      };
    case 'ARRIVED':
    case 'IN_QEMPO':
    case 'IN_QEMPO_CONFIRMED':
      return {
        innerState: '3p',
        labelIntl: 'order.purchase.arrived.title',
        labelIntlShort: 'order.purchase.arrived.title.short',
        labelIntlLong: 'order.purchase.arrived.title.long',
        hasExtra: false,
      };
    case 'SHIPPING':
    case 'DELIVERED':
      return {
        innerState: '4p',
        labelIntl: 'order.purchase.inTransit.shipping.title',
        labelIntlShort: 'order.purchase.inTransit.shipping.title.short',
        labelIntlLong: 'order.purchase.inTransit.shipping.title.long',
        hasExtra: false,
      };
    case 'DELIVERY_CONFIRMED':
      return {
        innerState: '5p',
        labelIntl: 'order.purchase.complete.title',
        labelIntlShort: 'order.purchase.complete.title.short',
        labelIntlLong: 'order.purchase.complete.title.long',
        hasExtra: false,
      };
    case 'ABANDONED':
    case 'EXPIRED':
    default:
      return {
        innerState: '0',
        labelIntl: 'order.purchase.abandoned.title',
        labelIntlShort: 'order.purchase.abandoned.title.short',
        hasExtra: false,
      };
  }
};

const stateConverter = (isSale: boolean, state: string): StateConvertResponse =>
  isSale ? saleConverter(state) : purchaseConverter(state);

const purchaseThreeStateConverter = (state: string): PurchaseInnerThreeState => {
  switch (state) {
    case 'CREATED':
    case 'BUYER_CANCELED':
    case 'QEMPO_CANCELED':
    case 'TRAVELER_CANCELED':
    case 'RETURNED':
    case 'QEMPO_CANCELED_FOR_FRAUD':
    case 'ABANDONED':
    case 'EXPIRED':
      return '0';
    case 'AVAILABLE':
    case 'RESERVED':
    case 'PURCHASED':
    case 'RECEIVED':
      return '1p';
    // case 'PURCHASED':
    // case 'RECEIVED':
    case 'ARRIVED':
    case 'IN_QEMPO':
    case 'IN_QEMPO_CONFIRMED':
    case 'SHIPPING':
    case 'DELIVERED':
      return '2p';
    case 'DELIVERY_CONFIRMED':
      return '3p';
    default:
      return '0';
  }
};

const saleThreeStateConverter = (state: string): SaleInnerThreeState => {
  switch (state) {
    case 'CREATED':
    case 'BUYER_CANCELED':
    case 'QEMPO_CANCELED':
    case 'TRAVELER_CANCELED':
    case 'RETURNED':
    case 'QEMPO_CANCELED_FOR_FRAUD':
    case 'ABANDONED':
    case 'EXPIRED':
      return '0';
    case 'AVAILABLE':
    case 'RESERVED':
      return '1s';
    case 'PURCHASED':
    case 'RECEIVED':
    case 'ARRIVED':
    case 'IN_QEMPO':
    case 'IN_QEMPO_CONFIRMED':
    case 'SHIPPING':
    case 'DELIVERED':
      return '2s';
    case 'DELIVERY_CONFIRMED':
      return '3s';
    default:
      return '0';
  }
};

export {
  purchaseInnerTrackingStates,
  saleInnerTrackingState,
  stateConverter,
  purchaseThreeStateConverter,
  saleThreeStateConverter,
}



// WEBPACK FOOTER //
// ./src/modules/order/utils/stateConverter.jsx